module.exports = __webpack_public_path__ + "static/assets/9b72c9b4439a7f1c690add6b45c51360.png";